import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ClouddnsWebsocketsEffect } from './clouddns-websockets.effect';
import { ModuleTokens } from './clouddns-websockets.constant';
import { reducer } from './clouddns-websockets.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      ModuleTokens.Name,
      reducer
    ),
    EffectsModule.forFeature([ ClouddnsWebsocketsEffect ])
  ]
})
export class ClouddnsWebsocketsModule {
}
